import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  styleMethods
} from 'dataviz/config/map.js';

import VizThumbnail from 'dataviz/VizThumbnail';

const baseString = 'vra-seed-rate-thumbnail';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedRateThumbnail = ({
  productValidationValues,
  script
}) => (
  <section className={classString}>
    <VizThumbnail
      config={{
        mapConfig: {
          fillMethod: styleMethods.seedRate.bind(null, script, productValidationValues)
        }
      }}
      zones={script.zones}
    />
  </section>
);
SeedRateThumbnail.propTypes = {
  productValidationValues: PropTypes.object.isRequired,
  script: PropTypes.object.isRequired
};
export default SeedRateThumbnail;
